module.exports = __webpack_public_path__ + "static/media/seo-consulting.2010f753.svg";